/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompanyGridItemViewModelPaginatedResponse } from "../types/CompanyGridItemViewModelPaginatedResponse.ts";
import { companyGridItemViewModelSchema } from "./companyGridItemViewModelSchema.ts";

export const companyGridItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => companyGridItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CompanyGridItemViewModelPaginatedResponse>;
